import {FC} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBriefcase, faChevronRight, faClock, faFolder,} from "@fortawesome/free-solid-svg-icons";
import {ProjectVisitItem} from "./type";
import {faLocationDot, faTag} from "@fortawesome/pro-solid-svg-icons";
import {ProjectVisitStatusLabel} from "../../../../lib/src/components/data/ProjectVisitStatusLabel";
import moment from "moment";

interface ProjectVisitSearchItemCardProps {
  item: ProjectVisitItem;
}
export const ProjectVisitItemCard: FC<ProjectVisitSearchItemCardProps> = props => {
  return <div className={'flex items-center hover:bg-blue-50 px-3 py-2 cursor-pointer'} onClick={() => props.item.navigate()}>
    <div className={'h-8 w-8 rounded-full bg-blue-200 text-blue-900 flex items-center justify-center mr-3'}>
      <FontAwesomeIcon icon={faBriefcase} />
    </div>

    <div className={'flex-1 flex flex-col items-start'}>
      <div className={'w-full grid grid-cols-4 gap-4 mb-1'}>
        <div className={'text-blue-900 font-semibold'}>
          <div>{props.item.name}</div>
        </div>

        <div className={'flex space-x-4 text-slate-600 text-sm'}>
          <div className={'flex space-x-2 items-center'}>
            <ProjectVisitStatusLabel projectVisitStatus={props.item.status} />
          </div>
        </div>

        <div className={'text-slate-600 text-sm'}>
          <div className={'flex space-x-2 items-center'}>
            <FontAwesomeIcon icon={faClock} />
            <div>{moment(props.item.targetDate).format('DD-MM-YYYY')}</div>
          </div>
        </div>
      </div>

      <div className={'w-full grid grid-cols-4 gap-4'}>
        <div className={'text-slate-600 text-sm'}>
          <div className={'flex space-x-2 items-center'}>
            <FontAwesomeIcon icon={faFolder} />
            <div>#{props.item.project?.projectNumber}</div>
            <span>&middot;</span>
            <div>{props.item.project?.description}</div>
          </div>
        </div>

        <div className={'text-slate-600 text-sm col-span-1'}>
          <div className={'flex space-x-2 items-center'}>
            <FontAwesomeIcon icon={faTag} />
            <div>{props.item.type}</div>
          </div>
        </div>

        <div className={'text-slate-600 text-sm col-span-2'}>
          <div className={'flex space-x-2 items-center'}>
            <FontAwesomeIcon icon={faLocationDot} />
            <div>{props.item.project?.deliveryAddressLine}<span>,</span></div>
            <div>{props.item.project?.deliveryZipCode}</div>
            <div>{props.item.project?.deliveryCity}</div>
          </div>
        </div>
      </div>
    </div>

    <FontAwesomeIcon icon={faChevronRight} className={'text-blue-900'} />
  </div>
}